import { DataTable } from "@components/DataTable/DataTable"
import { TitleValueList } from "@components/TitleValueList/TitleValueList"
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@components/ui/card"
import { useParams, useNavigate } from "react-router"
import { accountStatusHistoriesColumns } from "@pages/AgedAccounts/utils/tableColumnsSchema"
import { AccountStatusForm } from "@components/AccountNew/AccountStatusForms/AccountStatusForm"
import { AccountDetailsButton } from "@components/AccountDetailsButton"
import { Skeleton } from "@components/ui/skeleton"
import { useAgedAccountSerializer } from "./utils/agedAccountSerializerSchema"

export const EditAgedAccount = () => {
  const { account_id } = useParams() as { account_id: string }
  const navigate = useNavigate()

  const { data, isPending } = useAgedAccountSerializer(account_id)

  return (
    <div className="tw:flex tw:flex-col tw:gap-4">
      <h1 className="tw:text-center tw:text-4xl! tw:font-bold!"></h1>
      <Card>
        <CardHeader>
          <CardTitle className="tw:text-center tw:text-4xl tw:font-bold">
            {isPending ? (
              <Skeleton className="tw:mx-auto tw:h-10 tw:w-64" />
            ) : (
              `${data.first_name} ${data.last_name}`
            )}
          </CardTitle>
          <CardDescription className="tw:text-center tw:text-2xl">
            Account Info
          </CardDescription>
          <CardAction>
            {isPending ? (
              <Skeleton className="tw:h-8 tw:w-20" />
            ) : (
              <AccountDetailsButton
                membership_profile_id={data.membership_profile_id}
                account_id={data.account_id}
              />
            )}
          </CardAction>
        </CardHeader>
        <CardContent>
          <TitleValueList items={data.items} variant="gridClean" />
        </CardContent>
      </Card>
      <Card>
        <CardHeader>
          <CardTitle className="tw:text-2xl tw:font-bold">
            Update Account Status
          </CardTitle>
        </CardHeader>
        <CardContent>
          <AccountStatusForm onFormSuccess={() => navigate(-1)} />
        </CardContent>
      </Card>
      <Card>
        <CardHeader>
          <CardTitle className="tw:text-2xl tw:font-bold">
            Status History
          </CardTitle>
        </CardHeader>
        <CardContent>
          <DataTable
            pending={isPending}
            columns={accountStatusHistoriesColumns}
            data={data.account_status_histories ?? []}
          ></DataTable>
        </CardContent>
      </Card>
    </div>
  )
}
